export enum OperationScene {
    LOCAL_SAVE = 'local-save',
    LOCAL_SAVE_AS = 'local-save-as',
    ONLINE_FILE_OPEN = 'online-file-open',
    CLOUD_FILE_OPEN = 'cloud-file-open',
}

export enum ExFileType {
    /** 未知 */
    kUnknown = 0,
    /** 文件 */
    kFile = 1,
    /** 微云文件 */
    kWeiYun = 4,
    /** 腾讯文档 */
    kTencentDoc = 5,
}

export enum ExFileSource {
    /** 未知 */
    kUnknown = 0,
    /** 好友 */
    kC2C = 1,
    /** 群 */
    kGroup = 2,
    /** 本地：值是7，和上面不是连续的，这里要注意 */
    kLocal = 7,
}

enum ExTDocFileExt {
    kUnknown = 0,
    /** 文档 */
    kDoc = 1,
    /** 表格 */
    kXls = 2,
    /** 演示文稿 */
    kPpt = 3,
    /** 其他 */
    kOther = 4,
    /** PDF */
    kPdf = 12,
    /** 收集表 */
    kForm = 13,
    /** 智能文档 */
    kSmartDoc = 14,
    /** 智能表格 */
    kSmartSheet = 15,
    /** 智能白板 */
    kBoard = 16,
    /** 思维导图 */
    kMind = 17,
    /** 流程图 */
    kFlowChat = 18,
}

export type SaveToFileCenterParams = {
    /** QQ透传过来的hashId: 必填 */
    hashId: string;
    /** 文件名 */
    fileName: string;
    /** 文件路径 */
    filePath: string;
    /** 文件大小 */
    fileSize?: number;
    /** 本地自主生成，或者 C2C/群 */
    source?: ExFileSource;
    /** 文件类型：本地文件 or 云文件 or 在线文档 */
    fileType?: ExFileType;
    /** 这里要提供在线文件的后缀，参数见ExTDocFileExt，注意：这里的枚举值也是不连续的 */
    fileExt?: ExTDocFileExt;
    /** 如果是AIO/文件中心打开文档，这个参数是必须的 */
    qqInfo?: string;
};

export interface IQQMiniBridgeManager {
    /**
     * 保存到文件中心
     * @param scene
     * @returns
     */
    saveToFileCenter: (scene: OperationScene) => Promise<void>;
}
